import {
  FilterType,
  buildDocumentsDataTableFilter,
  useDocumentsDataTable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import { Team } from 'modules/employees/hooks/useTeams'

const teamFilter = (source: ReturnType<typeof useDocumentsDataTable>, teams: Team[]) => {
  const options = teams.map((team) => {
    return {
      value: team.id,
      label: team.name,
    }
  })

  return buildDocumentsDataTableFilter(source, {
    type: FilterType.Id,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
      },
    ],
    identifier: 'team_id',
    path: 'team',
    title: i18n.t('documents.employee.filters.team'),
  })
}

export default teamFilter
